// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sponsors-container {
    text-align: center;
    padding: 40px;
}

.sponsors-heading {
    margin-top: 30px;
    font-size: 2.5rem;
    margin-bottom: 20px;
    color: #2c3e50;
    font-weight: bold;
    text-transform: uppercase;
    letter-spacing: 1px;
}

.sponsor-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 20px;
    justify-content: center;
    align-items: center;
}

.sponsor-card {
    background: #ffffff;
    border-radius: 10px;
    padding: 20px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    text-align: center;
    transition: transform 0.3s ease;
}

.sponsor-card:hover {
    transform: scale(1.05);
}

.sponsor-photo {
    width: 150px;  /* Increased size */
    height: 150px; /* Keep aspect ratio */
    object-fit: cover;
    border-radius: 50%;
    margin-bottom: 10px;
}

.sponsor-info h3 {
    font-size: 1.5rem;
    margin-bottom: 5px;
}

.sponsor-year {
    font-weight: bold;
    color: #7f8c8d;
}

.sponsor-description {
    font-size: 1rem;
    color: #555;
    margin-bottom: 10px;
}

.linkedin-link {
    display: inline-block;
    background: #0077b5;
    color: #ffffff;
    padding: 8px 12px;
    border-radius: 5px;
    text-decoration: none;
    font-weight: bold;
    transition: background 0.3s ease;
}

.linkedin-link:hover {
    background: #005582;
}`, "",{"version":3,"sources":["webpack://./src/Components/sponsors.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;IACd,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;IACT,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,wCAAwC;IACxC,kBAAkB;IAClB,+BAA+B;AACnC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,YAAY,GAAG,mBAAmB;IAClC,aAAa,EAAE,sBAAsB;IACrC,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;IACrB,iBAAiB;IACjB,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;AACvB","sourcesContent":[".sponsors-container {\n    text-align: center;\n    padding: 40px;\n}\n\n.sponsors-heading {\n    margin-top: 30px;\n    font-size: 2.5rem;\n    margin-bottom: 20px;\n    color: #2c3e50;\n    font-weight: bold;\n    text-transform: uppercase;\n    letter-spacing: 1px;\n}\n\n.sponsor-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n    gap: 20px;\n    justify-content: center;\n    align-items: center;\n}\n\n.sponsor-card {\n    background: #ffffff;\n    border-radius: 10px;\n    padding: 20px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n    text-align: center;\n    transition: transform 0.3s ease;\n}\n\n.sponsor-card:hover {\n    transform: scale(1.05);\n}\n\n.sponsor-photo {\n    width: 150px;  /* Increased size */\n    height: 150px; /* Keep aspect ratio */\n    object-fit: cover;\n    border-radius: 50%;\n    margin-bottom: 10px;\n}\n\n.sponsor-info h3 {\n    font-size: 1.5rem;\n    margin-bottom: 5px;\n}\n\n.sponsor-year {\n    font-weight: bold;\n    color: #7f8c8d;\n}\n\n.sponsor-description {\n    font-size: 1rem;\n    color: #555;\n    margin-bottom: 10px;\n}\n\n.linkedin-link {\n    display: inline-block;\n    background: #0077b5;\n    color: #ffffff;\n    padding: 8px 12px;\n    border-radius: 5px;\n    text-decoration: none;\n    font-weight: bold;\n    transition: background 0.3s ease;\n}\n\n.linkedin-link:hover {\n    background: #005582;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
